module.exports = __webpack_public_path__ + "images/category_lp/bike/assessment_achievements/6_e2f2ab7a3ef55c7b4970e037d509b628.jpg";